 $(function() {
    const moment = require('moment-timezone');
    const timeZoneName = moment.tz.guess();
    const language = $('html')[0].lang;
    const myProject = require('./_data/myProject');
    const envSettings = myProject[myProject.environment];

    $.ajaxSetup({
        headers: { "X-TimeZoneName": timeZoneName, "X-Language": language },
        contentType: "application/json; charset=utf-8",
        dataType: "json"
    });

    const Uris = {
        jsonBookingsAdd: envSettings.server + "/json/competitions/addanswer",
        nextPageUri: "/fi//kiitos-yko/"
    };

    $("#ykoFormSendBtn").on("click", function(event) {
        if ($('#ykoForm')[0].checkValidity()) {
            $("#ykoFormSendBtn").prop("disabled", true);
            $("#ykoFormSendBtn").css("background-color", "#6c757d");
            let email = $("#ykoFormEmail").val();
            let firstName = $("#ykoFormFirstName").val();
            let lastName = $("#ykoFormLastName").val();
            let phone = $("#ykoFormPhoneNumber").val();
            let message = $("#ykoFormMessage").val();
            let organization = $("#ykoFormOrganization").val();
            let code = "";
           /*  if ($('#languageServicesNewsLetterCheckbox').is(':checked')) {
                code = "newsletter";
            } */
            let data = {
                email: email,
                firstName: firstName,
                lastName: lastName,
                additionalInformation: message,
                phoneNumber: phone,
                organizationName: organization,
                competitionName: "Yhteiskuntaorientaatio",
                uri: "/fi/yhteiskuntaorientaatio",
                languageCode: language,
                code: code,
            };

            console.log(data);

            // Disable the button to prevent multiple submissions
  

            $.ajax({
                url: Uris.jsonBookingsAdd,
                method: "POST",
                data: JSON.stringify(data)
            })
            .done(function() {
                window.location.href = Uris.nextPageUri;
            })
            .fail(function(err) {
                console.error(err);
                $("#ykoFormSendBtn").prop("disabled", false);
                $("#ykoFormSendBtn").css("background-color", "#28a745"); // Revert to active color
            });
        }
    });

    // Function to toggle button state based on form validity and checkbox
    function toggleSendButtonState() {
        const formValid = $('#ykoForm')[0].checkValidity;

        if (formValid) {
            // Enable button and change color
            $("#ykoFormSendBtn").prop("disabled", false);
            $("#ykoFormSendBtn").css("background-color", "#28a745"); // Change to your desired color (e.g., green)
        } else {
            // Disable button and reset color
            $("#ykoFormSendBtn").prop("disabled", true);
            $("#ykoFormSendBtn").css({
                "background-color": "#6c757d", // Change to your disabled color (e.g., grey)
                "border": "none",
                "outline": "none"
            });
        }
    }

    // Trigger the button state change on input and checkbox changes
    $('#ykoForm input').on('input change', toggleSendButtonState);



    // Initial button state check
    toggleSendButtonState();
});

